import axiosInstance from './axios-instance';

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem('accountId') || '0');
};

const getAllFees = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`fees/get-all`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const addNewFee = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`fees/add`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const deleteFee = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`fees/delete`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const editFee = async (payload: any) => {
  try {
    let clearedPayload = { ...payload };

    if (clearedPayload.quantity && clearedPayload.quantity.endsWith(".")) {
      clearedPayload.quantity = clearedPayload.quantity.slice(0, -1);
    }
    if (
      (clearedPayload.quantity && clearedPayload.quantity === '0') ||
      clearedPayload.quantity === '0.0' ||
      clearedPayload.quantity === '0.00'
    ) {
      clearedPayload.quantity = null;
    }

    const response = await axiosInstance.patch(`fees/update`, {
      ...clearedPayload,
      accountId: getScopedAccountId(clearedPayload?.accountId),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getAllFeeTypes = async (payload: any) => {
  try {
    const response = await axiosInstance.post(`fees/get-types`, {
      ...payload,
      accountId: getScopedAccountId(payload?.accountId),
    });

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getAllFees, addNewFee, deleteFee, editFee, getAllFeeTypes };
